// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import styled from 'styled-components';
import CompletionStatusTag from '../CompletionStatusTag';
import InfoText from '../NewCard/components/InfoText';
import { Link } from 'react-router-dom';
import { ToggleButton } from '../Collapse';

export const S = {
  Wrapper: styled.div`
    border: 1px solid #C9C9C9;
    margin-bottom: 16px;
    border-radius: 4px;
    width: 100%;
  `,
  // Chapter Header
  ChapterHeader: styled.div`
    display: flex;
    position: relative;
    align-items: center;
    padding: 18px 80px 18px 28px;
  `,
  ChapterTitle: styled.div`
    font-size: 16px;
    line-height: 23px;
    color: #313131;
  `,
  ChapterTotalContents: styled.div`
    flex-shrink: 0;
    margin-left: auto;
    display: flex;
    align-items: center;

    > * + * {
      margin-left: 12px;
    }
  `,
  InfoTotal: styled(InfoText)`
    flex-shrink: 0;
    display: flex;
    align-items: center;
    font-size: 16px;
    line-height: 23px;
    align-items: center;
    color: #313131;

    img {
      width: 20px;
      height: 20px;
      margin-right: 4px;
    }
  `,
  TotalDuration: styled.div`
    flex-shrink: 0;
    width: 74px;
    margin-left: 2px;
    text-align: right;
  `,
  ToggleButton: styled(ToggleButton)`
    position: absolute;
    top: 14px;
    right: 20px;
  `,
  // Chapter Content
  ChapterContentList: styled.div`
    border-top: 1px solid #C9C9C9;
    padding: 9px 0;
  `,
  // Module Contents
  LinkWrap: styled(Link)`
    color: #434343;

    &:first-child > * {
      border-radius: 4px 4px 0 0;
    }

    &:last-child > * {
      border-radius: 0 0 4px 4px;
    }
  `,
  HyperlinkWrap: styled.a`
    color: #434343;

    &:first-child > * {
      border-radius: 4px 4px 0 0;
    }

    &:last-child > * {
      border-radius: 0 0 4px 4px;
    }
  `,
  DisabledHyperlinkWrap: styled.div`
    cursor: not-allowed;
    color: #C9C9C9;
  `,
  DisabledLinkWrap: styled.div`
    cursor: not-allowed;
    color: #C9C9C9;
  `,
  DisabledTextWrap: styled.div`
    cursor: not-allowed;
    color: #C9C9C9;
  `,
  ChapterContentDetail: styled.div<{ isOwned: boolean }>`
    display:flex;
    padding: 15px 80px 15px 30px;

    ${props => props.isOwned && `
      &:hover {
        background: #F5F5F5;
      }`}
  `,
  ModuleIcon: styled.img`
    flex-shrink: 0;
    width: 24px;
    height: 24px;
  `,
  ChapterModuleName: styled.div`
    flex-grow: 1;
    margin-left: 20px;
    font-size: 16px;
    line-height: 26px;
    display: inline-flex;
  `,
  StateIcon: styled.div`
    flex-shrink: 0;
    display: flex;
    margin-left: 86px;
  `,
  CompletionStatusTag: styled(CompletionStatusTag)``,
  Duration: styled.div`
    flex-shrink: 0;
    margin-left: 16px;
    width: 74px;
    text-align: right;
  `,
  TextWrap: styled.div` 
  `,
  TextChapterModuleName: styled.div`
    flex-grow: 1;
    margin-left: 20px;
    font-size: 16px;
    line-height: 26px;
    display: inline-flex;
    font-style: italic;
  `,
  NoDataText: styled.p`
    text-align: center;
    line-height: 10rem;
  `,
};
